import { rootApi } from "../../app/apis/api.root";
import { API_TAGS } from "../../app/constants";
import { API_URL } from "../../constants/urls.constants";
import { CommonResponse, GetQueryArgsType } from "../../types";
import {
  DateWiseAmountsData,
  DueAmountData,
  MonthlyPaidInvoiceData,
  PayableDatesData,
  SummeryData,
  TopFiveVendorsData,
} from "./dashboard.type";

const { DASHBOARD } = API_TAGS || {};

export const vendorApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // Queries
    getDueAmounts: builder.query<
      CommonResponse<DueAmountData>,
      GetQueryArgsType<{ year: string; month: string }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDueAmount,
        ...queryArgs,
      }),
      providesTags: [{ type: DASHBOARD, id: "due-amounts" }],
    }),
    getSummery: builder.query<
      CommonResponse<SummeryData>,
      GetQueryArgsType<{ year?: string; month?: string }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getSummery,
        ...queryArgs,
      }),
      providesTags: [{ type: DASHBOARD, id: "summery" }],
    }),

    getMonthlyPaidInvoiceData: builder.query<
      CommonResponse<MonthlyPaidInvoiceData>,
      GetQueryArgsType<{ year: string }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getMonthlyPaidInvoiceData,
        ...queryArgs,
      }),
      providesTags: [{ type: DASHBOARD, id: "monthly-paid-invoice" }],
    }),

    getTopFiveVendors: builder.query<
      CommonResponse<TopFiveVendorsData>,
      GetQueryArgsType<{ year?: number; month?: number }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getTopFiveVendors,
        ...queryArgs,
      }),
      providesTags: [{ type: DASHBOARD, id: "top-five-vendors" }],
    }),

    getPayableDates: builder.query<
      CommonResponse<PayableDatesData>,
      GetQueryArgsType<{ year?: number; month?: number }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getPayableDates,
        ...queryArgs,
      }),
      providesTags: [{ type: DASHBOARD, id: "payable-dates" }],
    }),

    getDateWiseAmounts: builder.query<
      CommonResponse<DateWiseAmountsData>,
      GetQueryArgsType<{ date: string }>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDateWiseAmount,
        ...queryArgs,
      }),
      providesTags: [{ type: DASHBOARD, id: "date-wise-amount" }],
    }),
  }),
});

export const {
  useGetDueAmountsQuery,
  useGetSummeryQuery,
  useGetMonthlyPaidInvoiceDataQuery,
  useGetTopFiveVendorsQuery,
  useGetPayableDatesQuery,
  useGetDateWiseAmountsQuery,
} = vendorApi;
